import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Hand18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M7.5 2.75C7.89783 2.75 8.25 3.10217 8.25 3.5V11H9.75V8.75H11.25V11H12.75V8.75C13.5146 8.75 14.25 9.1474 14.25 10V16H15.75V10C15.75 8.50217 14.4978 7.25 13 7.25H9.75V3.5C9.75 2.2745 8.7255 1.25 7.5 1.25C6.2745 1.25 5.25 2.2745 5.25 3.5V9.25H4.5C3.2745 9.25 2.25 10.2745 2.25 11.5V16H3.75V11.5C3.75 11.1022 4.10217 10.75 4.5 10.75H5.25V13.5H6.75V3.5C6.75 3.10217 7.10217 2.75 7.5 2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Hand18.displayName = 'Hand18';
export default Hand18;
